import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {GroupModel} from '../../../../../models/school/group.model';
import {SchoolAdminGroupObjectiveChangeService} from './school-admin-group-objective-change.service';
import {ModalService} from '../../../../../shared/modals/modal/modal.service';
import {TranslateService} from '@ngx-translate/core';
import {ErrorModel} from '../../../../../models/shared/error.model';

@Component({
  selector: 'app-school-admin-group-objective-change',
  templateUrl: './school-admin-group-objective-change.component.html',
  styleUrls: ['./school-admin-group-objective-change.component.css']
})
export class SchoolAdminGroupObjectiveChangeComponent implements OnChanges {

  @Input() groupId: string;
  @Input() group: GroupModel;
  @Output() groupUpdated = new EventEmitter<GroupModel>();

  constructor(
    public sv: SchoolAdminGroupObjectiveChangeService,
    private modalSv: ModalService,
    private tSv: TranslateService
  ) {}

  ngOnChanges(changes: SimpleChanges) {

    if (this.groupId && this.group) {
      this.sv.init(this.groupId, this.group);
    }

  }

  canProceed(): boolean {

    if (this.sv.pendingObjectiveId === undefined) {
      return false;
    }

    const currentObjectiveId = this.group ? (this.group.objectiveId || null) : null;
    if (this.sv.pendingObjectiveId === currentObjectiveId) {
      return false;
    }

    return true;

  }

  onConfirmChange() {

    this.sv.confirmChange().subscribe((group) => {

      this.sv.isConfirming = false;
      this.sv.pendingObjectiveId = undefined;
      this.sv.objectives = [];
      this.groupUpdated.emit(group);
      this.sv.init(this.groupId, group);
      this.modalSv.showAlertModal(
        this.tSv.instant('reusable.success'),
        this.tSv.instant('reusable.successMessage')
      );

    }, (err: ErrorModel) => {

      this.modalSv.showTranslatedErrorModal(err);

    });

  }

}
